import { Item, ItemDescription, ItemHeader, ItemTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { AiAgentChatListItem } from '@/entities/ai-agent-chat';

type Props = {
  chat: AiAgentChatListItem;
  onClick: (id: number) => void;
};

const MAX_PREVIEW_LENGTH = 60;

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const truncateText = (text: string, maxLength: number) => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
};

export const CopilotChatCard: FC<Props> = ({ chat, onClick }) => {
  const { t } = useTranslation(['aiAgent']);

  const title =
    chat.title ||
    (chat.lastMessage ? truncateText(chat.lastMessage.content, MAX_PREVIEW_LENGTH) : t('aiAgent:emptyChat'));

  return (
    <Item variant="outline" size="sm" role="button" tabIndex={-1} onClick={() => onClick(chat.id)}>
      <ItemHeader>
        <ItemTitle>{title}</ItemTitle>
        <span className="text-xs text-muted-foreground shrink-0">{formatDate(chat.updatedAt)}</span>
      </ItemHeader>
      {chat.lastMessage && (
        <ItemDescription>{truncateText(chat.lastMessage.content, MAX_PREVIEW_LENGTH)}</ItemDescription>
      )}
    </Item>
  );
};
